/* eslint-disable react/display-name */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Size, Color } from '../../const'

const TextInputWithIcon = React.forwardRef(
  (
    {
      className,
      label,
      unit,
      type,
      value,
      maxLength,
      name,
      width,
      height,
      outPadding,
      inPadding,
      border = `solid 1px ${Color.LINE.POWER_BLUE}`,
      borderRadius = '5px',
      fontSize = '16px',
      fontWeight = '300',
      bgColor = '#fff',
      onChange,
      onClick,
      onBlur,
      onKeyPress,
      errorMessage,
      placeholder,
      ariaLabel,
      disabled = false,
      min,
      max,
      step,
      readOnly = false,
      subfix = null,
      containerClick,
      subfixClick,
    },
    ref
  ) => {
    return (
      <Wrapper outPadding={outPadding} className={className}>
        {label && <Label>{label}</Label>}
        {unit && <Unit>{unit}</Unit>}
        <InputGroup>
          <InputWrapper bgColor={bgColor} onClick={containerClick} border={border} borderRadius={borderRadius}>
            <InputStyle
              width={width}
              height={height}
              inPadding={inPadding}
              border={border}
              fontSize={fontSize}
              fontWeight={fontWeight}
              type={type}
              name={name}
              value={value}
              maxLength={maxLength}
              onChange={onChange}
              onClick={onClick}
              onBlur={onBlur}
              onKeyPress={onKeyPress}
              placeholder={placeholder}
              aria-label={ariaLabel}
              disabled={disabled}
              min={min}
              max={max}
              step={step}
              ref={ref}
              readOnly={readOnly}
            />
            {subfix && <Subfix onClick={subfixClick}>{subfix}</Subfix>}
          </InputWrapper>
          <Error>{errorMessage}</Error>
        </InputGroup>
      </Wrapper>
    )
  }
)

const Wrapper = styled.div(
  (props) => `
  display: inline-flex;
  width: 100%;
  padding: ${props.outPadding ? props.outPadding : '8px 0'};
  `
)

const InputGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  column-gap: 4px;
  align-items: center;
  background-color: ${(props) => props.bgColor};
  padding-right: 16px;
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
`

const Subfix = styled.div`
  cursor: pointer;
`

const Label = styled.label`
  width: 30%;
  padding-right: 30px;
  text-align: right;
  vertical-align: top;
  font-size: ${Size.FONT.LABEL};
`

const Unit = styled.label`
  padding: 0 2px 0 5px;
  text-align: right;
  vertical-align: top;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '18px')};
`

const InputStyle = styled.input`
  padding: ${(props) => (props.inPadding ? props.inPadding : '12px 16px')};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  vertical-align: top;
  text-align: left;
  color: ${(props) => (props.disabled ? '#C0C0C0' : '#242e3d')};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: 0.21px;
  border: none;
  border-radius: 1px;
  background: none;
  outline: none;

  &::placeholder {
    color: #a5a5a5;
  }
`

const Error = styled.div`
  color: ${Color.FONT.DANGER};
`

TextInputWithIcon.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLength: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  border: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  bgColor: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  errorMessage: PropTypes.object,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.string,
  borderRadius: PropTypes.string,
}

export default TextInputWithIcon
